import styled from 'styled-components'
import { SIZES } from '../../utils/constants'

export const AuthorContainer = styled.div`
  padding-left: 1.4rem;
  margin-top: 2rem;
  text-align: start;
  @media screen and (min-width: ${SIZES.md}px) {
    padding-left: 2rem;
  }
`
